const FEEDBACK = 'Feedback';

export const feedbackConstants={
    FEEDBACK
};